import { AiOutlineFileText, AiOutlineNumber } from 'react-icons/ai';
import { ReportingControllerBaseConfig } from '../../../base';
import { RecordOverlayController } from './recordOverlayInterface';
import { RecordOverlayViewProps } from './recordOverlayProps';
import { Property } from '@varos/research-sdk';
import { BsCalendar, BsCheck, BsLink, BsTextLeft } from 'react-icons/bs';
import { assertNever } from '@varos/util-typescript';
import {
    MdOutlineArrowDropDownCircle,
    MdOutlineManageSearch,
    MdStarBorder,
} from 'react-icons/md';

export function createRecordOverlayController(
    config: ReportingControllerBaseConfig
): RecordOverlayController {
    function getIcon(property: Property) {
        if (property.type === 'text' || property.type === 'string') {
            return BsTextLeft;
        }
        if (property.type === 'integer' || property.type === 'float') {
            return AiOutlineNumber;
        }
        if (property.type === 'boolean') {
            return BsCheck;
        }
        if (property.type === 'date') {
            return BsCalendar;
        }
        if (property.type === 'datetime') {
            return BsCalendar;
        }
        if (property.type === 'link') {
            return BsLink;
        }
        if (property.type === 'rating') {
            return MdStarBorder;
        }
        if (property.type === 'relation') {
            return MdOutlineManageSearch;
        }
        if (property.type === 'enum') {
            return MdOutlineArrowDropDownCircle;
        }
        assertNever(property);
    }
    return {
        useProps(context, item, props): RecordOverlayViewProps {
            return {
                collection: {
                    label: item.collection.display_name,
                },
                title: item.content.title,
                open: {
                    // button: {
                    //     onClick() {
                    //         props.onFullScreen();
                    //     },
                    // },
                    link: {
                        to: props.fullscreen.link.to,
                    },
                },
                property: {
                    items: item.collection.properties.map((property) => ({
                        id: property.key,
                        label: property.display_name,
                        description: property.description,
                        Icon: getIcon(property),
                        value: {
                            collection: item.collection.id,
                            item: {
                                property: property,
                                value: item.content.properties[property.key] ?? null,
                            },
                        },
                    })),
                },
            };
        },
    };
}
